import { TimesheetsSummaryTimeType, TimesheetsSummaryType } from '@/api/types/general/TimesheetsType'
import TimesheetsTotalUnitTimeEnum from '@/utilities/timesheets/total/enums/TimesheetsTotalUnitTimeEnum'
import TimesheetsTotalTimeConverterInterface from '@/utilities/timesheets/total/interfaces/TimesheetsTotalTimeConverterInterface'

export default class TimesheetsTotalTimeConverter implements TimesheetsTotalTimeConverterInterface {
  handle(summary: TimesheetsSummaryType[]): TimesheetsSummaryType[] {
    return summary.map(item => ({
      ...item,
      time: item.time.map(time => this.convert(time)),
    }))
  }

  convert(time: TimesheetsSummaryTimeType): TimesheetsSummaryTimeType {
    let value = time.value

    switch (time.unit) {
      case TimesheetsTotalUnitTimeEnum.MINUTE:
        value = value / 60
        break
      case TimesheetsTotalUnitTimeEnum.SECOND:
        value = value / 3600
        break
    }

    return {
      ...time,
      value: Number(value.toFixed(2)),
    }
  }
}
